import { build } from "../../tools/ConfigBuilder";
import { lazy } from "react";

export default build([
	{
		path: "/admin/parsing-tools",
		component: lazy(() => import("./AdminParsingToolsPage")),
	},
]);
